import { render } from "./AsahiBsFooter.vue?vue&type=template&id=30b4f882&scoped=true&ts=true"
import script from "./AsahiBsFooter.vue?vue&type=script&lang=ts"
export * from "./AsahiBsFooter.vue?vue&type=script&lang=ts"

import "./AsahiBsFooter.vue?vue&type=style&index=0&id=30b4f882&scoped=true&lang=scss"

import exportComponent from "/srv/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30b4f882"]])

export default __exports__